import { generateRandomIdentifier, UIService } from './../../ui.service';
import {
  FileDetailsDTO, DocumentVersionDTO, DocumentFileTypeDTO, TemplateDTO, DocumentDTO, getSimpleIdentifierFromString,
  BaseEntityDTO, DocumentClassDTO, BlobFileDetails, TaskDTO, ActionTypeDTO, MasterDataDTO, DivisionDTO,
  OrganizationalUnitDTO
} from '../../api/plyca-dtos';
import { TaskHandler } from '../../tasks/TaskHandler';
import { Component, OnInit, ElementRef, AfterContentInit, OnDestroy, Input } from '@angular/core';
import { TemplateDTOModal, templateModalComponent } from './basicDocumentModal.component';
import { TranslateService } from '@ngx-translate/core';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { catchError, finalize, map, switchMap, take, takeUntil, takeWhile, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Observable, of, throwError, timer } from 'rxjs';
import { DataRetrieverConfig, FieldConfig, MasterData } from '../../api/contract-notice-dto';
import { Configuration } from '../../conf/app.constants';
import { PlycaDataService } from '../../../services/plyca.service';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { PropertyService } from '../../properties/property.service';
import { UserService } from '../../user.service';
import { AppConfiguration } from '../../conf/app.configuration';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { PRIMENG_DATE_FORMAT } from '../../../services/language.service';
import * as lodash from 'lodash';
import { PaginationDTO } from '../../api/PaginationModel';
import { DossierSituation } from '../../api/plyca-dtos-v2';
import { SelectItem } from 'primeng-lts/api';

@Component({
  selector: 'basicDocument',
  templateUrl: 'basicDocument.template.html',
  providers: [DialogService, UIService]
})
export class basicDocumentComponent extends TaskHandler
  implements OnInit, AfterContentInit, OnDestroy {
  documento: DocumentDTO;
  customFieldsDef: Array<any> = [];
  tagsParent: string[] = [];
  templates: TemplateDTO[];
  template: TemplateDTO;
  availablePhases: Array<any> = [];
  selectedPhase: MasterDataDTO;

  possibleConfidentialityLevels: Array<SelectItem> = [];
  possibleLocales: Array<SelectItem> = [];
  selectedLocale: string = null;
  desiredLocale: string = null;
  dossierLocale: string = null;

  public drafFiles: Array<FileDetailsDTO>;
  public PRIMENG_DATE_FORMAT = PRIMENG_DATE_FORMAT;
  public dossierId: string;
  public dossier: any;
  completeDocument = false;
  downloadActive: any;
  editActive: any;
  pdfConversionEnabled: boolean;
  pdfConversionPreviewEnabled: boolean;

  loaded = false;
  documentClassEditable = true;
  hideDocumentPanel = false;


  defaultPhaseSearch = 'EXPFASE';

  public documentClass: DocumentClassDTO;
  public division: DivisionDTO;
  public phase: MasterData;

  public isPopup = false;
  public windowHash: string;

  private forceRelease = false;
  enableChangeConfLevel = false;

  constructor(
    public plycaService: PlycaDataService,
    public dialogService: DialogService,
    private elem: ElementRef,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    public configuration: Configuration,
    public propertyService: PropertyService,
    public userService: UserService,
    private plycaErrorHandler: PlycaErrorHandler,
    public appConfig: AppConfiguration,
    private translationService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig
  ) {

    super();

    if (dialogConfig?.data) {
      this.isPopup = true;
      this.windowHash = generateRandomIdentifier();
      this.dossierId = dialogConfig.data.dossierId;
      this.division = dialogConfig.data.division;
      this.documentClass = dialogConfig.data.documentClass;
      this.phase = dialogConfig.data.phase;
      this.documentClassEditable = false;
      if (dialogConfig.data.locale) {
        this.desiredLocale = dialogConfig.data.locale;
        this.selectedLocale = this.desiredLocale;
      }
    } else {
      this.subscribe(this.activatedRoute.queryParams,
        (params) => {
          this.dossierId = params['dossierId'];
          this.forceRelease = params['forceRelease'] === 'true';
        }
      );
    }
    this.possibleConfidentialityLevels.push({ value: 'NotRestricted', label: this.translateService.instant('DocumentView.confidentiality.NotRestricted') });
    this.possibleConfidentialityLevels.push({ value: 'LimitedDiffusion', label: this.translateService.instant('DocumentView.confidentiality.LimitedDiffusion') });
    this.possibleConfidentialityLevels.push({ value: 'Confidential', label: this.translateService.instant('DocumentView.confidentiality.Confidential') });
    this.possibleConfidentialityLevels.push({ value: 'Anonymized', label: this.translateService.instant('DocumentView.confidentiality.Anonymized') });


    this.subscribe(this.propertyService.getProperty('GENERAR_PDF'), (value: string) => { this.pdfConversionEnabled = (value === '1'); });
    this.subscribe(this.propertyService.getProperty('PDF_PREVIEW_ENABLED'), (value: string) => { this.pdfConversionPreviewEnabled = (value === 'true'); });
  }
  ngAfterContentInit(): void {
    this.visibleCompleteDocument();
    if (!this.task) {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.ADD_DOCUMENT));
    }
    let element: HTMLElement = document.getElementById('focus');
    if (element != null) {
      element.focus();
    }
  }

  visibleCompleteDocument(): void {
    // check de docuemtno completo
    this.subscribe(this.propertyService.getProperty('PERFILES_SET_FLAG_DOC_FINALIZADO'), (value: string) => {
      if (value == null || value === '') {
        this.completeDocument = false;
      } else {
        value = value.replace(new RegExp(/[;]/g), ',');
        if (this.userService.hasRoles(value)) {
          this.completeDocument = true;
        } else {
          this.completeDocument = false;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    //TODO ¿se abre como modal en algun sitio??????????
    /* if (!this.isPopup) {
       this.helpService.showContextHelp(this.tagsParent);
     }*/
    this.dialogConfig = null;
    this.dialogRef = null;
    super.ngOnDestroy();
  }

  ngOnInit(): void {
    /*
     "basicdocument.template.download.active": true,
      "basicdocument.file.edit.active": true
      */
    // Se establece por configuración si la plantilla se descarga o se incluye en el documento.
    this.downloadActive = this.appConfig.getValue('basicdocument.template.download.active');
    if (this.task !== undefined) {
      if (this.task.work["desiredLocale"]) {
        this.desiredLocale = this.task.work["desiredLocale"];
      }
      this.dossierLocale = this.task.division.project.locale;
      this.filterPossibleLocales(this.task.division.project.organizationalUnit);

      // ayuda con tarea
      this.subscribe(
        this.helpService.getStoreTagsObservable().pipe(
          switchMap((taskTags) => {

            return this.helpService.showContextHelpObservable(taskTags.concat(HelpType.ADD_DOCUMENT));


          }))
      );
      let idTarea: string = this.task.identifier;
      console.log('Abriendo tarea de mensaje: ' + idTarea);
      this.documento = this.task.work.document;
      if (this.task && this.task.procedure && this.task.procedure.phase) {
        this.selectedPhase = this.task.procedure.phase;
      }
      if (!this.selectedPhase) {
        this.selectedPhase = this.documento.entity.division.phase;
      }
      if (!this.selectedLocale) {
          this.selectedLocale = this.documento.locale;
          if (!this.selectedLocale)
            this.selectedLocale = this.dossierLocale;
      }
      // this.documento['rejectionComment'] = this.documentService.getRejectComment(this.documento);
      this.initDraftFiles();
      this.initCustomFields();
      this.loaded = true;
      this.waitService.cancelWaiting();
    } else {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.ADD_DOCUMENT));
      this.documento = new DocumentDTO();
      this.documento = <DocumentDTO>{};
      this.documento.entity = <BaseEntityDTO>{};
      this.documento.entity.division = this.division;
      this.documento.entity.documentClass = this.documentClass;
      this.documento.phase = this.phase;

      // TODO: LLAMAR AL SERVICIO NEW PARA CREAR DOCUMENTO
      // if (!this.dossier) {
      this.subscribe(this.plycaService.getDossier(this.dossierId, 'expansionSet:detail,organizationalUnit,organizationalUnit.entityDTO'), param => {
        this.dossier = param;
        if (this.dossier) {
          this.dossierLocale = this.dossier.locale;
          if (!this.selectedLocale)
            this.selectedLocale = this.dossierLocale;
          this.filterPossibleLocales(this.dossier.organizationalUnit);
        }
        this.initDraftFiles();
        if (!this.isPopup) {
          this.headerActionsService.setProject(this.elem, this.dossier, true);
          this.headerActionsService.setTaskDescription(
            this.elem,
            this.translateService.instant('BasicDocument.new'),
            'fas fa-inbox',
            true
          );
        }
        let value = null;
        if (this.isPopup) {
          this.loadDoc();
        } else {
          try {
            // let dossierConfig = this.appConfig.getValue('dossierConfig');
            // value = dossierConfig[this.dossier.division.documentClass.application]['documentoManual.fixedDocumentClass'];
            value = this.appConfig.getValueByDossierType(this.dossier.division.documentClass.application, 'documentoManualfixedDocumentClass');
          } catch { }
          if (value) {
            this.subscribe(
              this.plycaService.get<DocumentClassDTO>(
                this.configuration.DOCUMENTCLASS_SERVICE_URL,
                value, { 'expand': 'configuration' }),
              (documentClass: DocumentClassDTO) => {
                this.documento.entity.documentClass = documentClass;
                this.documentClassEditable = false;
              });
          }
        }
        this.loaded = true;
        this.waitService.cancelWaiting();
      });
    }
    this.setHeaderActions();
    if (this.task !== undefined) {
      let flag = this.task.taskData.find(v => v.name === 'BOTON_DESCARTAR_DOCUMENTO');
      if (flag && flag.value != null && 'true' === flag.value.toString().toLowerCase()) {

        let profiles = this.propertyService.instant('PERFILES_BOTON_DESCARTAR_DOCUMENTO');

        let isProfileAllowed = true;
        if (profiles != null && profiles != undefined) {
          isProfileAllowed = this.userService.hasRoles(profiles, this.task.division.project.application);
        }

        if (this.task.division.project.status != null && this.task.division.project.status.situation === DossierSituation.Support) {
          isProfileAllowed = false;
        }

        if (isProfileAllowed) {
          this.subscribe(this.headerActionsService.addAction('General.discardDocument', 'fa fa-save', 'btn-secondary', true,
            function () {
              return this.activateDiscardDocument(this.documento);
            }.bind(this)),
            () => {
              this.discardDocument();
            });
        }
      }
      let dataShowPanel = this.task.taskData.find(v => v.name === 'MOSTRAR_FICHA_DOCUMENTO');
      this.hideDocumentPanel = dataShowPanel && dataShowPanel.value === 'false';

    }
  }
    
  private filterPossibleLocales(org: OrganizationalUnitDTO) {
	    let activeLocales = null;
	    if (org) {
	      if (org.entity) {
	        activeLocales = org.activeLocales;
	      } else if (org.entityDTO) {
	        activeLocales = org.entityDTO.activeLocales;
	      }
	    }

	    if (!activeLocales || activeLocales.includes('es_ES'))
	      this.possibleLocales.push({ value: 'es_ES', label: this.translateService.instant('Languages.es') });
	    if (!activeLocales || activeLocales.includes('ca_ES'))
	      this.possibleLocales.push({ value: 'ca_ES', label: this.translateService.instant('Languages.ca') });
	    if (!activeLocales || activeLocales.includes('gl_ES'))
	      this.possibleLocales.push({ value: 'gl_ES', label: this.translateService.instant('Languages.gl') });
	    if (!activeLocales || activeLocales.includes('eu_ES'))
	      this.possibleLocales.push({ value: 'eu_ES', label: this.translateService.instant('Languages.eu') });

	  }


  private setHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService.addWindowAction(
      'BasicDocument.preview.action',
      'fas fa-file-pdf ',
      'btn-secondary',
      () => this.isVisible_PreviewAction(),
      this.windowHash
    ),
      () => this.previewDocument()
    );
    if (this.downloadActive) {
      this.subscribe(this.headerActionsService.addWindowAction(
        'BasicDocument.generate.from.model',
        'fa fa-file-text',
        'btn-secondary',
        () => !this.gestionarSinAdjuntos(),
        this.windowHash
      ),
        () => this.openSelectorTemplate()
      );
    } else {
      this.subscribe(this.headerActionsService.addWindowAction(
        'BasicDocument.generate.from.template',
        'fa fa-file-text',
        'btn-secondary',
        () => !this.gestionarSinAdjuntos(),
        this.windowHash
      ),
        () => this.openSelectorTemplate()
      );
    }
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.save',
      'fa fa-save',
      'btn-primary',
      true,
      this.windowHash,
      () => this.activarGuardar(this.documento),
    ),
      () => this.save()
    );
    this.headerActionsService.addWindowDivider(this.windowHash);
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.cancel',
      'fas fa-times',
      'btn-secondary',
      true,
      this.windowHash),
      () => {
        if (this.isPopup) {
          this.dialogRef.close(undefined);
        } else {
          this.salir();
        }
      }
    );
  }

  activateDiscardDocument(doc: any) {
    return this.task !== undefined && this.documento.identifier;
  }

  activarGuardar(doc: any) {
    return (doc.entity.division && doc.entity.documentClass && doc.entity.documentClass.configuration)
  }

  gestionarSinAdjuntos(): boolean {
    // Está configurado con plantilla automática y tiene campos personalizables
    return this.documento && this.documento.entity
      && this.documento.entity.documentClass
      && this.documento.entity.documentClass.configuration
      && this.documento.entity.documentClass.configuration.generateTemplateAuto
      && this.customFieldsDef && this.customFieldsDef.length > 0;
  }
  
  getCustomFieldTitle(): string {
	    if (this.task) {
	      let data = this.task.taskData.find(x => x.name == 'CUSTOMFIELDS_TITLE');
	      if (data)
	        return data.value;
	    }
	    return 'BasicDocument.customFieldsTitle';
	  }

  public getBuscadorTipoDocumentosConfig(): FieldConfig {
    let config = new FieldConfig();
    config.editable = this.documentClassEditable;
    config.type = 'SEARCH';
    config.jsonField = 'entity.documentClass';
    config.description = this.translateService.instant('BasicDocument.type');
    config.fieldStyle = 'plForm-element';
    config.autoSearch = false;
    // let propertyName = 'dossierConfig.' + this.dossier.documentoClass.application + '.documentoManual.documentClassSearch';

    let value = null;
    try {
      // let dossierConfig = this.appConfig.getValue('dossierConfig');
      // value = dossierConfig[this.dossier.division.documentClass.application]['documentoManual.documentClassSearch'];
      value = this.appConfig.getValueByDossierType(this.dossier.division.documentClass.application, 'documentoManual.documentClassSearch');
    } catch { }
    if (value == null || value === '') {
      value = 'DOCNOESTRUC_OBJPORFLUJO';
    }
    config.idBuscador = value;
    // });
    if (this.dossier && this.dossier.division) {
      config.parameters = [{
        'identifier': 'OBJPORFLUJO.LISTADOCID', 'value': '\''
          + this.dossier.division.documentClass.identifier + '\''
      }, {
        'identifier': 'OBJPORFLUJO.PROCONTRID', 'value': '\''
          + getSimpleIdentifierFromString(this.dossier.division.procedure.identifier) + '\''
      }, {
        'identifier': 'LISTADOCUMENTO.TABLA', 'value': '\'DOCNOESTRUC\''
      }];
    }
    return config;
  }
  public getPhaseSearchId(): string {
    let searchId = this.appConfig.getValueByDossierType(this.dossier.division.documentClass.application, 'documentoManual.phases.search');
    if (searchId == undefined || searchId == null) {
      searchId = this.defaultPhaseSearch;
    }
    return searchId;
  }

  public getBuscadorFaseConfig(): FieldConfig {

    let searchId = this.getPhaseSearchId();
    let config = new FieldConfig();
    if (searchId !== this.defaultPhaseSearch) {
      config.type = 'DROPDOWN';
      config.jsonField = 'selectedPhase';
      config.description = this.translateService.instant('BasicDocument.fase');
      config.fieldStyle = 'plForm-element';
      let divId = this.documento?.entity?.division?.identifier;
      config.editable = divId !== undefined && !this.isPopup;
      config.dataConfig = new DataRetrieverConfig();
      config.dataConfig.jsonPath = 'availablePhases';
      config.dinamicOptionsActive = true;
      config.orderByDescription = false;
      config.showClearOption = false;
    } else {
      config.type = 'DROPDOWN';
      config.jsonField = 'selectedPhase';
      config.description = this.translateService.instant('BasicDocument.fase');
      config.fieldStyle = 'plForm-element';
      config.idBuscador = searchId;
      config.editable = !this.isPopup;
    }

    return config;
  }


  public getBuscadorDivisionTree(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'DIVISION';
    config.jsonField = 'entity.division';
    config.description = this.translateService.instant('BasicDocument.division');
    config.fieldStyle = 'plForm-element';
    config.idBuscador = this.dossierId;
    config.editable = true;
    return config;
  }



  private loadTemplates(): Observable<any> {
    if (this.task !== undefined) {
      return this.plycaService.findTemplatesByTask(this.task);
    } else {

      if (this.documento
        && this.documento.entity
        && this.documento.entity.documentClass
        && this.documento.entity.division
        && this.documento.entity.division.identifier) {
        let div = getSimpleIdentifierFromString(this.documento.entity.division.identifier);
        return this.plycaService.findTemplatesByDocument(
          this.documento.entity.documentClass.identifier,
          this.dossier.identifier,
          div

        );
      } else {

        return this.uiService.showMessage(
          this.translateService.instant('BasicDocument.templates.divisionAlert')
        ).onClose.pipe(
          map(
            () => { return 'NODIVISION' })
        );





      }

    }
  }

  openSelectorTemplate() {
    // Si hay campos personalizables  guardamos antes de generar plantilla, de esta manera las plantillas tendrán en cuenta estos valores
    if (this.documento.customFields
      && Object.keys(this.documento.customFields).length > 0) {
      this.subscribe(this.saveDocument(),
        (() => {
          this.processTemplate();
        }
        ));

    } else {
      return this.processTemplate();

    }
  }



  processTemplate() {
    this.waitService.startWaiting();
    this.subscribe(this.loadTemplates(),
      (param: any) => {
        if (param === 'NODIVISION') {
          console.log('No hay división seleccionada');
        } else if (param != null && param.content) {
          this.templates = param.content;
          if (this.templates.length > 1) {
            let config: DynamicDialogConfig = {
              header: this.translationService.instant('BasicDocumentModal.title'),
              width: '60%',
              style: { 'max-height': '60%' },
              styleClass: 'searchStyle'
            };

            config['context'] = new TemplateDTOModal(this.templates);

            const refDialog = this.dialogService.open(
              templateModalComponent,
              config
            );
            refDialog.onClose.pipe(take(1)).subscribe(result => {
              if (result) {
                this.waitService.startWaiting();
                this.template = result;
                this.generateTemplate();
              } else {
                console.log('dialog cancelado');
              }
            });
          } else {
            // Solo hay una plantilla, se genera directamente
            this.waitService.startWaiting();
            this.template = this.templates[0];
            this.generateTemplate();
          }
        } else {
          this.uiService.showMessage(this.translateService.instant('BasicDocument.templates.noavailable')
          ).onClose.pipe(take(1)).subscribe(() => this.waitService.cancelWaiting());
        }
      });
  }

  generateTemplate(): void {
    this.getDocumentClassConfiguration();
    console.log('GENERANDO TEMPLATE A PARTIR DE DOCUMENTO: ', this.documento);
    this.waitService.startWaiting();
    let observable: Observable<any>;
    if (this.task !== undefined) {
      observable = this.plycaService.generateTemplateByTask(
        this.task,
        this.template
      );
    } else {
      let params = '';
      let aux = '';
      if (this.documento.entity) {
        if (this.documento.entity.division) {
          params +=
            aux +
            'division=' +
            getSimpleIdentifierFromString(
              this.documento.entity.division.identifier
            );
        } else {
          params += aux + 'division=0';
        }
        aux = '&';
        params +=
          aux +
          'documentClassId=' +
          this.documento.entity.documentClass.identifier;
        params += aux + 'projectEntityId=' + this.dossier.identifier;
        observable = this.plycaService.generateTemplateByDocumentClass(
          this.template,
          params
        );
      }
    }
    this.subscribe(observable
      .pipe(
        finalize(() => {
          this.waitService.cancelWaiting();
        })
      ),
      (fileDetails: FileDetailsDTO) => {
        if (
          this.documento.currentVersion &&
          this.documento.currentVersion.files != null
        ) {




          if (this.documento.entity.documentClass.configuration.allowMultipleFiles
            || !this.drafFiles || this.drafFiles.length === 0) {
            if (this.downloadActive) {
              this.downloadFile(fileDetails);

            } else {
              this.documento.currentVersion.files.push(fileDetails);

              this.initDraftFiles();
            }


          } else {
            this.uiService.showMessage(this.translateService.instant(
              'Upload.noMoreFiles.error'
            ));
          }



        } else {
          this.addFileItem(fileDetails);
        }
        // this.loading.next(new LoadingInfo(false));
      },
      err => {
        console.log('Error al generateTemplate', err);
        // this.loading.next(new LoadingInfo(false));

        this.uiService.showMessage(
          'No se ha encontrado plantilla para el documento seleccionado'
        );
      }
    );
  }

  addFileItem(fileItem: FileDetailsDTO) {
    // confirmar si se puede eliminar al haber aplicado el patchDTO
    if (!this.documento.currentVersion) {
      this.documento.currentVersion = {} as DocumentVersionDTO;
      this.documento.currentVersion.files = [] as FileDetailsDTO[];
    }
    if (this.documento.entity.documentClass.configuration && this.documento.entity.documentClass.configuration.allowMultipleFiles
      || !this.drafFiles || this.drafFiles.length === 0) {
      this.documento.currentVersion.files.push(fileItem);
    } else {
      this.uiService.showMessage(this.translateService.instant(
        'Upload.noMoreFiles.error'
      ));
    }

    this.initDraftFiles();
  }

  deleteFileItem(fileItem: FileDetailsDTO) {

    console.log('Remove item ');
    this.confirmationService.confirm({
      message: this.translationService.instant('General.confirm.action.delete'),
      accept: () => {

        if (this.documento.currentVersion.files != null) {
          let id: number;
          for (let i = 0; i < this.documento.currentVersion.files.length; ++i) {
            if (
              this.documento.currentVersion.files[i].identifier ===
              fileItem.identifier
            ) {
              id = i;
              break;
            }
          }
          this.documento.currentVersion.files.splice(id, 1);
        }
        this.initDraftFiles();
      }
    });


  }

  modifyFileItem(items: any) {

    let fileItemToDelete: FileDetailsDTO;
    let fileItemToAdd: FileDetailsDTO;
    fileItemToDelete = items['delete'];
    fileItemToAdd = items['add'];
    // El componente upload a cargado el nuevo file y envia este evento, borramos el file que se editó
    if (this.documento.currentVersion.files != null) {
      let id: number;
      for (let i = 0; i < this.documento.currentVersion.files.length; ++i) {
        if (
          this.documento.currentVersion.files[i].identifier ===
          fileItemToDelete.identifier
        ) {
          id = i;
          break;
        }
      }
      this.documento.currentVersion.files.splice(id, 1);
      this.initDraftFiles();
      this.addFileItem(fileItemToAdd);
    }
  }


  private initDraftFiles(): void {
    this.drafFiles = this.getDraftFiles();
  }

  private getDraftFiles(): Array<FileDetailsDTO> {
    let allFiles: Array<FileDetailsDTO> = [];
    if (
      this.documento.currentVersion != null &&
      this.documento.currentVersion.files != null
    ) {
      let tmpDrafFiles = this.documentService.getTypeDocument(
        DocumentFileTypeDTO.Draft,
        this.documento
      );
      let temporalFiles = this.documentService.getTypeDocument(
        DocumentFileTypeDTO.Temporal,
        this.documento
      );
      allFiles = tmpDrafFiles.concat(temporalFiles);
    }
    return allFiles;
  }

  // isLoaded(): boolean {
  //   return !this.loading;
  // }
  changeCompletedMark(newValue: any) {
    if (newValue) {
      this.uiService.showConfirmMessage({
        message: this.translateService.instant(
          'BasicDocument.completeDocumentWarning'
        ),
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.documento.markedAsCompleted = true;
        },
        reject: () => {
          this.documento.markedAsCompleted = false;
        }
      });
    } else {
      this.documento.markedAsCompleted = false;
    }
  }

  saveWorkObservable(reactivate = false): Observable<any> {
    this.setFileDescription();
    return super.saveWorkObservable(reactivate);
  }

  private setFileDescription(): void {
    let temporalFiles = this.getDraftFiles();
    // arrastrar descripcion del documento al adjunto temporal
    if (temporalFiles && temporalFiles.length > 0) {
      temporalFiles.forEach((file: FileDetailsDTO, index: number) => {
        file.description = this.documento.name + ((!index) ? '' : '(' + index + ')');
      });
    }
  }

  discardDocument() {
    if (this.task === undefined && !this.documento.identifier) {
      return;
    }
    if (!this.documento.identifier) {
      this.dispatchTask();
    }

    this.uiService.showConfirmMessage({
      message: this.translateService.instant('ExpenseManagement.actions.cancelDocument.message'),
      header: this.translateService.instant('General.confirmtext'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.doCancelDocument()
    });

  }

  private doCancelDocument() {
    this.waitService.startWaiting();

    this.subscribe(this.dispatchTask().pipe( // Guardar el documento
      switchMap((response: any) => this.cancelDocument(this.documento.identifier)),
      tap((response: any) => {
        this.waitService.cancelWaiting();
        // Evitamos que se intente desbloquear
        this.isTaskUnlocked = true;
        this.uiService.routeBack();
        this.uiService.showSuccess(
          this.translateService.instant('Actions.exec.ok'),
          this.translateService.instant('General.info'),
          'success'
        );
      })
    ),
      catchError((error: any) => {
        console.error(error);
        this.uiService.showMessage('Se ha producido un error al realizar la operación de anulación');
        return throwError(error);
      }))

  }

  cancelDocument(identifier: string): Observable<any> {
    let url = this.configuration.DOCUMENT_EVENT_URL.replace('{documentIdentifier}', identifier);
    url = url.replace('{eventId}', 'CancelDocument');
    url += "?force=true";
    return this.plycaService.simpleUpdate(url, new Object());
  }

  dispatchTask(): Observable<any> {
    if (this.task && this.task.availableActions && this.task.availableActions.actions && this.task.availableActions.actions.length > 0) {

      const actionDispatch = this.task.availableActions.actions.find((obj) => {
        return obj.identifier === ActionTypeDTO.TASK_DISPATCH;
      });

      if (!actionDispatch) {
        // No tiene la accion de despachar
        // De momento se la copiamos de mantener
        let action = this.task.availableActions.actions[0];
        action = lodash.cloneDeep(action);
        action.identifier = ActionTypeDTO.TASK_DISPATCH;
        let url: string;
        url = action.links[0].href;
        url = url.substr(0, url.lastIndexOf('/'));
        url += '/dispatch';
        action.links[0].href = url;
        this.task.availableActions.actions.push(action);
      }
    }
    return this.taskService.dispatchTask(this.task);

  }

  save() {
    this.waitService.startWaiting();
    this.subscribe(this.saveDocument(this.forceRelease).pipe(
      tap(
        (response: any) => {
          if (this.isPopup) {
            this.dialogRef.close(response);
          } else if (this.task !== undefined) {
            this.waitService.cancelWaiting();
            this.openModal();
          } else {
            this.waitService.cancelWaiting();
            console.log('Documento creado/actualizado!!', response);
            this.uiService.showSuccess(this.translationService.instant('Actions.exec.ok'),
              this.translationService.instant('General.info'),
              'success');
            this.uiService.routeBack();
          }
        }
      )
    )
    )
  }

  private saveDocument(forceRelease = false): Observable<any> {
    if (forceRelease && this.task === undefined && !this.documento.currentVersion.released) {
      // Configurar para que genere versión y no se quede en borrador.
      this.documento.currentVersion.released = true;
    }
    let obs: Observable<any>;
    this.documento.phase = this.selectedPhase;
    this.documento.locale = this.selectedLocale;
    if (this.task !== undefined) {
      obs = this.saveWorkObservable().pipe(
        tap((task: TaskDTO) => {
          this.documento = this.task.work.document;
        })
      );
    } else {
      if (!this.documento.identifier) {
        this.setFileDescription();
        console.log('creando documento: ', this.documento);

        obs = this.plycaService.insert<DocumentDTO>(this.configuration.DOCUMENTS_SERVICE_URL, this.documento)
          .pipe(
            switchMap((document: DocumentDTO) => {
              let obsDoc: Observable<any>;
              obsDoc = this.plycaService.getDocument(document.identifier, 'expand=entity.documentClass,entity.division,entity.documentClass.configuration,currentVersion,customFieldDefinitions');
              return obsDoc.pipe(
                map((doc: any) => {
                  this.documento = doc;
                  return doc;
                })
              );
            })
          );
      } else {
        obs = this.plycaService
          .update<DocumentDTO>(
            this.configuration.DOCUMENTS_SERVICE_URL,
            this.documento
          )
          .pipe(
            switchMap(() => {
              let obsDoc: Observable<any>;
              obsDoc = this.plycaService.getDocument(this.documento.identifier, 'expand=entity.documentClass,entity.division,entity.documentClass.configuration,currentVersion,customFieldDefinitions');
              return obsDoc.pipe(
                map((doc: any) => {
                  this.documento = doc;
                  return doc;
                })
              );
            })
          );
      }

      obs = obs.pipe(
        catchError(error => {
          this.waitService.cancelWaiting();
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      );
    }
    return obs.pipe(
      tap(() => {
        this.initDraftFiles();
        this.initCustomFields();
      }),
    )
  }

  canDeactivate() {
    if (this.task !== undefined) {
      return super.canDeactivate();
    } else {
      // TODO: IMPLEMENTAR CONTROL DE CUANDO SE PUEDE SALIR SIN PERDER CAMBIOS
      return of(true);
    }
  }

  searchPhasesOfDivision(idBuscador: string) {

    // SI cambiamos la division y no eliminamos la fase actual seleccionada
    // el combo incorpora la fase del documento de la division anterior si no lo limpiamos
    this.selectedPhase = null;

    let searchUrl = this.configuration.SEARCH_SETTINGS_SERVICE_URL + idBuscador + '/values?';

    searchUrl += 'PROPUESTAID' + '=' + this.dossier.identifier;
    searchUrl += '&';
    searchUrl += 'DIVISION' + '=' + this.documento?.entity?.division?.identifier;

    this.subscribe(this.plycaService
      .query<any>(searchUrl)
      .pipe(
        catchError(
          () =>
            (this.availablePhases = [])
        )
      ),
      (s: PaginationDTO<any>) => {
        this.availablePhases = [];
        if (s.content) {
          s.content.map((data) => {
            this.availablePhases.push(data.singleValue);
          });

        }
      });
  }


  newDocument(chageDocType: boolean, element: any) {

    // establecemos la fase de la division seleccionada
    if (this.documento.entity
      && this.documento.entity.division
      && this.documento.entity.division.phase) {
      this.documento.phase = this.documento.entity.division.phase;
    }
    if (!chageDocType) {
      let searchId = this.getPhaseSearchId();
      if (searchId !== this.defaultPhaseSearch) {
        this.searchPhasesOfDivision(searchId);
      }
    }

    if (chageDocType && element.oldValue != undefined) {
      this.uiService.showConfirmMessage({
        message: this.translateService.instant('BasicDocument.confirm.change'),
        header: this.translateService.instant('General.confirm.text'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.drafFiles = [];
          this.loadDoc();
        },
        reject: () => {

          this.documento.entity.documentClass = element.oldValue;

        }
      });

    } else {
      this.loadDoc();
    }


  }


  private loadDoc() {
    this.subscribe(this.plycaService.get<DocumentClassDTO>(this.configuration.DOCUMENTCLASS_SERVICE_URL,
      this.documento.entity.documentClass.identifier, {
      'expand': 'expansionSet:full'
    }),
      (documentClass: DocumentClassDTO) => {
        this.documento.entity.documentClass.configuration = documentClass.configuration;

        if (
          this.documento.entity.documentClass &&
          this.documento.entity.division
        ) {
          this.waitService.startWaiting();
          let url = this.configuration.DOCUMENTS_SERVICE_URL;
          this.subscribe(this.plycaService
            .get<DocumentDTO>(url, 'new', {
              projectId: this.dossierId,
              documentClassId: this.documento.entity.documentClass.identifier,
              divisionId: getSimpleIdentifierFromString(
                this.documento.entity.division.identifier
              )
            }).pipe(finalize(() => {
              this.selectedPhase = this.documento.entity.division.phase;
              this.getDocumentClassConfiguration();
              this.initDraftFiles();
              this.waitService.cancelWaiting();

            }),
              catchError(e => {
                if (e && e.error && e.error.errors && e.error.errors[0] && e.error.errors[0].message) {
                  this.uiService.showMessage(e.error.errors[0].message
                  ).onClose.pipe(take(1)).subscribe(() => {
                    this.documento.entity.division = undefined;
                  });
                }
                this.waitService.cancelWaiting();
                return throwError(e);
              })),
            d => {
              // if (d.customFields) {
              this.documento.customFields = d.customFields;
              // } else {
              //   this.documento.customFields = {};
              // }
              this.documento.currentVersion = d.currentVersion;
              // this.documento.entity = d.entity;
              this.documento.name = d.name;
              this.documento.customFieldDefinitions = d.customFieldDefinitions;
              this.initCustomFields();
            });

        }
      }
    );
  }


  private getDocumentClassConfiguration() {
    this.subscribe(this.plycaService.get<DocumentClassDTO>(this.configuration.DOCUMENTCLASS_SERVICE_URL,
      this.documento.entity.documentClass.identifier, {
      'expand': 'expansionSet:full'
    }),
      (documentClass: DocumentClassDTO) => this.documento.entity.documentClass.configuration = documentClass.configuration);
  }

  initCustomFields() {
    if (!this.documento.customFields) {
      this.documento.customFields = {};
    }
    let cfFilteredKeys;
    if (this.task && this.task.taskData.find(x => x.name == 'CUSTOMFIELDS_FILTER')) {
      cfFilteredKeys = this.task.taskData.find(x => x.name == 'CUSTOMFIELDS_FILTER').value.split(';');
    } else if (this.task && this.task.taskData.find(x => x.name == 'PARAMS_TAREA')) {
      let paramsTask = this.task.taskData.find(x => x.name == 'PARAMS_TAREA').value.split('#@#');
      if (paramsTask.find(x => x.startsWith('CUSTOMFIELDS_FILTER='))) {
        let customFilterParam = paramsTask.find(x => x.startsWith('CUSTOMFIELDS_FILTER=')).split('=');
        if (customFilterParam.length == 2) {
          cfFilteredKeys = customFilterParam[1].split(';');
        }

      }
    }
    this.customFieldsDef = [];
    if (this.documento.customFieldDefinitions) {
      Object.keys(this.documento.customFieldDefinitions)
        .filter(cfKey => !cfFilteredKeys || cfFilteredKeys.filter(x => x == cfKey).length > 0)
        .forEach(
          cfKey => {
            this.customFieldsDef.push(
              this.getFieldConfigFromCustomField(
                this.documento.customFieldDefinitions[cfKey]
              )
            );
          }
        );
    }
  }


  getFieldConfigFromCustomField(customFieldDef: any) {
    // 1. INIT VALUE
    if (this.documento.customFields[customFieldDef.name] === undefined) {
      this.documento.customFields[customFieldDef.name] = '';
    }
    // 2. FIELDCONFIG
    let config = new FieldConfig();
    config.jsonField = customFieldDef.name;
    config.description = customFieldDef.display.i18nDescription;
    config.fieldStyle = 'plForm-element ' + customFieldDef.format;
    // config.idBuscador = this.dossierId;

    if (customFieldDef.type === 'MasterData' && customFieldDef.origin) {
      config.type = 'DROPDOWN';
      config.data = [];
      // comprobacion por si hay algun problema en la parametrizacion del campo y no llegan los valores posibles
      if (customFieldDef.origin.possibleValues) {
        customFieldDef.origin.possibleValues.forEach((val) =>
          config.data.push({ label: val.description, value: val })
        );
      }
    } else if (customFieldDef.type === 'Check' || customFieldDef.type === 'Boolean') {
      config.type = 'YES_NO';
    } else if (customFieldDef.type === 'Timestamp') {
      config.type = 'DATETIME';
    } else if (customFieldDef.type === 'Date') {
      config.type = 'DATE';
    } else if (customFieldDef.type === 'Number') {
      config.type = 'INTEGER';
    } else if (customFieldDef.type === 'Decimal') {
      config.type = 'DECIMAL';
      config.maxDecimals = 2;
    } else if (customFieldDef.type === 'Text') {
      config.type = 'TEXTAREA';
      config.maxlength = 4000;
    } else if (customFieldDef.origin && customFieldDef.origin.search) {
      config.type = 'SEARCH';
      config.idBuscador = customFieldDef.origin.search.identifier;
    } else {
      config.type = 'TEXT';
      config.maxlength = 4000;
    }
    return config;
  }

  sortedCustomFields() {
    return this.customFieldsDef.sort((a, b) => a.jsonField > b.jsonField ? 1 : a.jsonField === b.jsonField ? 0 : -1);
  }

  downloadFile(fileItem: FileDetailsDTO) {
    // console.log("Método downloadFile");

    this.documentService.downloadEmbedded(fileItem);
  }

  // Previsualización de documentos
  private previewDocument(): void {
    console.log('Previsualizando documento: ', this.documento);
    this.waitService.startWaiting();
    if (this.documento?.currentVersion?.released) {
      let originals = this.documento.currentVersion.files.filter(
        file => file.fileType == 'Original'
      );
      // No permitimos previsualizar si no hay documento que visualizar
      if (!originals || originals.length == 0) {
        console.log('No existe documento a visualizar');
        this.waitService.cancelWaiting();
        return;
      }
      let fileDetails = originals[0];
      // Si no ponemos nombre hay procesos que fallan, y si no acaba en .pdf no sale la opción de descargar/imprimir
      this.documentService.viewFile(fileDetails);
      this.waitService.cancelWaiting();
    } else {
      // No permitimos previsualizar si no hay documento que visualizar
      if (!this.drafFiles || this.drafFiles.length <= 0) {
        let message = this.translateService.instant('BasicDocument.preview.error')
        this.uiService.showMessage(message);
        this.waitService.cancelWaiting();
        return;
      }


      this.subscribe(this.saveDocument().pipe( // Guardar el documento
        switchMap((response: any) => this.plycaService.documentService_requestCreatePreview(this.documento.identifier)),
        switchMap((response: any) => timer(1000, 1000)),
        takeUntil(this.waitService.getEscapeObservable()),
        switchMap((iteracion: number) => this.plycaService.documentService_downloadPreview(this.documento.identifier)),
        tap((blob: Blob) => {
          console.log('blob=', blob);
          if (blob !== null) {
            console.log('fin, blob=', blob);
            let blobFileDetails = new BlobFileDetails();
            blobFileDetails.fileContent = blob;
            blobFileDetails.name = this.documento.name + '_draft.pdf';
            // Si no ponemos nombre hay procesos que fallan, y si no acaba en .pdf no sale la opción de descargar/imprimir
            this.documentService.viewFile(blobFileDetails);
            this.waitService.cancelWaiting();
          }
        }),
        takeWhile((blob: Blob) => blob === null)
      ))
    }
  }

  isVisible_PreviewAction(): boolean {
    // Si la version esta cerrada se vera si tiene algun original que mostrar
    if (this.documento?.currentVersion?.released) {
      let originals = this.documento.currentVersion.files.filter(
        file => file.fileType == 'Original'
      );
      return originals && originals.length > 0;
    };

    // Por defecto no se visualiza
    let visible = false;

    if (this.documento?.entity?.documentClass?.configuration != null
      && this.documento?.entity?.documentClass?.abbreviation != null
      && this.pdfConversionEnabled != null
      && this.pdfConversionPreviewEnabled != null
    ) {
      visible = true;

      // El documento no debe ser multidocumento
      visible = visible && !this.documento.entity.documentClass.configuration.multidocument;

      // El documento debe tener habilitada la conversión PDF
      visible = visible && this.documento.entity.documentClass.configuration.pdfConversionEnabled;

      // El documento no debe ser de tipo OTR
      visible = visible && this.documento.entity.documentClass.abbreviation != 'OTR';

      // La conversión a PDF está habilitada
      visible = visible && this.pdfConversionEnabled;

      // La previsualización a PDF está habilitada
      visible = visible && this.pdfConversionPreviewEnabled;
    }

    return visible;
  }
  

  localeSet(): boolean {
    return this.desiredLocale && (!this.dossierLocale || this.desiredLocale !== this.dossierLocale)
  }
  localeToBeSet(): boolean {
    return !this.desiredLocale && this.possibleLocales.length > 1
  }

}
